var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#5EBFC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.704 16.9211C17.7718 16.7856 17.9103 16.7 18.0618 16.7H19.3382C19.6356 16.7 19.829 17.0129 19.696 17.2788L18.9854 18.7H19.3C19.6296 18.7 19.8178 19.0763 19.62 19.34L17.1097 22.687C16.8375 23.05 16.2668 22.751 16.4103 22.3205L17.0838 20.3H16.6618C16.3645 20.3 16.1711 19.987 16.304 19.7211L17.704 16.9211ZM18.1854 17.3L16.9854 19.7H17.3613C17.6343 19.7 17.8271 19.9674 17.7407 20.2264L17.3692 21.341L18.9 19.3H18.6618C18.3645 19.3 18.1711 18.987 18.304 18.7211L19.0146 17.3H18.1854Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.375 10H11.625C10.7275 10 10 10.7275 10 11.625V22.125C10 23.0225 10.7275 23.75 11.625 23.75H24.375C25.2725 23.75 26 23.0225 26 22.125V11.625C26 10.7275 25.2725 10 24.375 10ZM11.625 9C10.1753 9 9 10.1753 9 11.625V22.125C9 23.5747 10.1753 24.75 11.625 24.75H24.375C25.8247 24.75 27 23.5747 27 22.125V11.625C27 10.1753 25.8247 9 24.375 9H11.625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0001 24.875H13.0001V26.5C13.0001 26.9142 13.3359 27.25 13.7501 27.25H22.2501C22.6643 27.25 23.0001 26.9142 23.0001 26.5V24.875ZM12.0001 23.875V26.5C12.0001 27.4665 12.7836 28.25 13.7501 28.25H22.2501C23.2166 28.25 24.0001 27.4665 24.0001 26.5V23.875H12.0001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12.5H13L13 14.875H23V12.5ZM13 11.5C12.4477 11.5 12 11.9477 12 12.5V14.875C12 15.4273 12.4477 15.875 13 15.875H23C23.5523 15.875 24 15.4273 24 14.875V12.5C24 11.9477 23.5523 11.5 23 11.5H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEnergy);
export default __webpack_public_path__ + "static/media/active-energy.924461a6.svg";
export { ForwardRef as ReactComponent };